export default "__VITE_ASSET__BcjksxHB__"